import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import Parameters from '@/services/Sierra/Sparameter/parameter';
import { getFileInSierraPinToPinProject } from '@/services/api/sierra';
import { ResultData } from '@/services/Sierra';
import { getResultList } from '@/services/helper/sparameter/dataProcess';
import { strDelimited } from '@/services/helper/split';
import { downloadFile } from '@/services/helper/downloadHelper'
import Sparameter from '../components/Sparameter';
import {
  sparameterShowCurves,
  getVCCompsPCB,
  parseEndToEndResult,
  setEndToEndParameters,
  getEndToEndTreeList
} from '@/services/Sierra/helper/sparameterDataHelper'
import makeCancelable from '@/services/api/makeCancelable';
import { getEndToEndResultList } from '../../../../services/Sierra/results';
import { cancelMove, getMouseMoveYAxisValue } from '../../../../services/Result/Public/sparameter/dataHelper';
import { getEndToEndMouseMoveYAxisValue, /* cancelEndToEndMove */ } from '../../../../services/Sierra/helper/sparameterDataHelper';
import resultOperation from '../../../../services/Result/Public/resultOperation';
import { CHANNEL } from '../../../../services/Result/Public/resultConstants';
import { END_TO_END, RESULT } from '../../../../components/ResultTreeList/nodeRender';

const defaultState = {
  files: [],
  portSelect: {},
  Interfaces: {},
  resultList: {},
  hasVcPCBs: [],
  hideIL: false,
  endToEndCurveMouseObj: {},
  expandedKeys: [],
  expandedEndToEndKeys: [],
  endToEndTree: {},
}
class Channel extends Component {

  constructor(props) {
    super(props);
    this.uploadSP = createRef();
    this.uploadSnpRef = createRef();
    const { verificationId } = props;
    const resultOpera = resultOperation.getOperationByKey(verificationId, CHANNEL) || {};
    this.state = {
      ...defaultState,
      resultOpera: resultOpera || {}
    }
    this.plot2d = null;
  }

  changeMouse = (frequency) => {
    try {
      let { files, resultList, endToEndList } = this.state;
      const displayMode = this.childComp.getDisplayMode();

      const axis = this.childComp.getAxis();
      const yScale = axis.yScale;
      const selectArr = this.childComp.getCurrentSelects();
      let _resultList = { ...resultList }, _endToEndList = [...(endToEndList || [])];
      const setting = this.childComp.getSetting();
      for (let pcb in _resultList) {
        _resultList[pcb] = getMouseMoveYAxisValue({
          resultsObj: _resultList[pcb],
          displayMode,
          selectArr,
          files,
          x: frequency,
          setting,
          yScale
        })
      }
      const endToEndCurveMouseObj = getEndToEndMouseMoveYAxisValue({
        displayMode,
        selectArr,
        setting,
        endToEndList: _endToEndList,
        files,
        x: frequency,
        yScale
      })

      this.setState({
        resultList: _resultList,
        /* endToEndList: _endToEndList, */
        endToEndCurveMouseObj
      });
    } catch (error) {
      console.error(error)
    }
  }

  cancelMove = () => {
    try {
      let { resultList } = this.state;
      const selectArr = this.childComp.getCurrentSelects();
      const displayMode = this.childComp.getDisplayMode();
      let _resultList = { ...resultList };
      for (let pcb in _resultList) {
        _resultList[pcb] = cancelMove({
          resultsObj: _resultList[pcb],
          displayMode,
          selectArr,
        })
      }
      this.setState({
        resultList: _resultList,
        endToEndCurveMouseObj: {},
        /* endToEndList: cancelEndToEndMove({ endToEndList, displayMode }) */
      });
    } catch (error) {
      console.error(error)
    }
  }

  componentDidUpdate(prevProps) {
    const { verificationId, verificationSubId, projectId } = this.props;
    if (verificationId !== prevProps.verificationId && verificationSubId) {
      const resultOpera = resultOperation.getOperationByKey(verificationId, CHANNEL) || {};
      this.setState({
        ...defaultState,
        portSelect: {},
        resultList: {},
        resultOpera: resultOpera || {}
      }, () => {
        this.removeAllCurves();
        Parameters.cleanParameters();
        ResultData.getVerificationJsonPromise(verificationSubId, verificationId, projectId).then(res => {
          if (res) {
            let Interfaces = ResultData.getInterfaces();
            const _Interfaces = { ...this.state.Interfaces };
            _Interfaces[verificationId] = Interfaces;
            const { hasVcPCBs,/*  hideIL */ } = getVCCompsPCB(Interfaces);
            this.setState({
              Interfaces: _Interfaces,
              hasVcPCBs,
              /*  hideIL */
            }, () => {
              this.changeResult();
            })
          }
        })

        if (this.selectAllCancelAble) {
          this.selectAllCancelAble.cancel();
        }
        if (this.childComp) {
          const { displayMode = 'Default' } = resultOpera;
          this.childComp.updateDisplayModeModel(displayMode)
        }
      });
    }
  }

  componentWillUnmount = () => {
    if (this.selectAllCancelAble) {
      this.selectAllCancelAble.cancel();
    }
  }

  componentDidMount() {
    const { verificationSubId, projectId, verificationId } = this.props;
    this.setState({
      ...defaultState,
      portSelect: {},
      resultList: {},
    });
    if (verificationSubId && verificationId) {
      ResultData.getVerificationJsonPromise(verificationSubId, verificationId, projectId).then(res => {
        if (res) {
          let Interfaces = ResultData.getInterfaces();
          const _Interfaces = { ...this.state.Interfaces };
          _Interfaces[verificationId] = Interfaces
          const { hasVcPCBs,/*  hideIL */ } = getVCCompsPCB(Interfaces);
          this.setState({
            Interfaces: _Interfaces,
            hasVcPCBs,
            /*  hideIL */
          }, () => {
            this.changeResult();
          })
        }
      })
    }
  }

  changeResult = () => {
    const events = {
      changeMouse: this.changeMouse,
      cancelMove: this.cancelMove,
      changeAxis: this.childComp.changeAxis,
    }
    Parameters.cleanParameters();
    this.childComp.setLoading(true)
    this.setState({
      portSelect: {},
      resultList: {}
    }, () => {
      this.mounted = true;
      const { verificationId, verificationSubId, projectId, channelList } = this.props;
      const { parameter, value } = this.childComp.getSetting();
      this.plot2d = Parameters.createPlot(this.childComp.svgRef.current, { param: parameter, value }, events);
      Parameters.getParametersInfo({ verificationId, verificationSubId, projectId, channelList }).then(params => {
        const parametersArr = Array.from(params.values());
        if (parametersArr.length > 0) {
          let files = Array.from(params.values()).map(item => ({ ...item, show: true }));
          let expandedKeys = [RESULT]
          this.getAllNpi(files).then(res => {
            this.childComp.setLoading(false)
            expandedKeys = [...new Set([...expandedKeys, ...res.map(item => item.id)])];
            this.setState({
              files: [...res.map(item => ({ ...item, show: true, rowName: item.pcb, rowId: item.pcb }))],
              expandedKeys
            }, () => {
              const displayMode = this.childComp.getDisplayMode();
              if (displayMode === 'Default') {
                this.defaultResultList();
              } else {
                this.findResultList();
              };
              this.getEndToEndResult();
            })
          }, error => {
            this.childComp.setLoading(false)
            this.setState({
              files: files,
              expandedKeys: [RESULT]
            }, () => {
              const displayMode = this.childComp.getDisplayMode();
              if (displayMode === 'Default') {
                this.defaultResultList();
              } else {
                this.findResultList();
              };
            })
          })
        } else {
          this.childComp.setLoading(false)
          this.setState({
            files: [],
          }, () => {
            const displayMode = this.childComp.getDisplayMode();
            if (displayMode === 'Default') {
              this.defaultResultList();
            } else {
              this.findResultList();
            };
          });
          return message.error('No result!');
        }
      });
      this.childComp.screenChange();
    })
  }

  getAllNpi = (files) => {
    const { verificationId } = this.props;
    const { Interfaces } = this.state;
    const promiseList = files.map((item, index) => {
      const content = Interfaces[verificationId].find(d => item.id.includes(d.pcbId));
      return item.getNpiFile(index, verificationId, content);
    })
    return Promise.all(promiseList);
  }

  getSingleNpi = (file) => {
    const { files } = this.state;
    const { verificationId } = this.props;
    let length = files.length >= 0 ? files.length : 0;
    const promiseList = file.map((item, index) => {
      return item.getNpiFile(length, verificationId);
    })
    return Promise.all(promiseList);
  }

  getEndToEndResult = async () => {
    const { files } = this.state;
    const { verificationId, verificationSubId, projectId } = this.props;
    const res = await getEndToEndResultList(verificationId);
    const endToEndList = parseEndToEndResult(res);
    const { endToEndList: endToEndParametersArr, files: newFiles } = setEndToEndParameters({
      endToEndList,
      Parameters,
      verificationId,
      verificationSubId,
      projectId,
      files
    });
    this.setState({
      endToEndList: endToEndParametersArr,
      files: newFiles,
      expandedEndToEndKeys: endToEndParametersArr.length ? [END_TO_END] : [],
      endToEndTree: getEndToEndTreeList(endToEndParametersArr)
    }, () => {
      const { resultOpera } = this.state;
      const { portSelect = {} } = resultOpera;
      if (Object.keys(portSelect).length) {
        this.showSavedEndToEndCurves()
      }
    })
  }

  fileDownload = (e, file) => {
    e.stopPropagation();
    let filename;
    const { verificationId } = this.props;
    getFileInSierraPinToPinProject(file.projectId, `${verificationId}/result/${file.name}`).then(res => {
      let content = ''
      if (res) {
        content = res.data;
      }
      const Suffix = file.name.match(/\.s[0-9]{1,}p/i)[0];
      filename = file.pcb + '_channel' + Suffix;
      downloadFile(content, filename)

    }, error => {
      console.error(error);
      let content = ''
      const Suffix = file.name.match(/\.s[0-9]{1,}p/i)[0];
      filename = file.pcb + '_channel' + Suffix;
      downloadFile(content, filename)
    });
  }

  removeAllCurves = () => {
    const { portSelect } = this.state;
    const selects = Object.values(portSelect).reduce((a, b) => {
      return a.concat(b);
    }, []);
    let ports = [...selects];
    const removeCurves = ports.map(curve => {
      const [fileId, row, col] = strDelimited(curve, "::");
      return { row, col, id: fileId };
    });
    if (removeCurves.length) {
      Parameters.removeCurves(removeCurves);
    };
  }

  getColorByIndex = (fileId, row, col) => {
    const { files } = this.state;
    const _file = files.find(file => file.id === fileId);
    return _file ? _file.matrix[row][col].color : "";
  }

  getDefaultExpandedKeys = () => {
    const { files } = this.state;
    const _files = files.filter(item => item.type !== "end-to-end");
    return [RESULT, ...new Set(_files.map(item => item.id))];
  }

  defaultResultList = () => {
    const { resultList, files, Interfaces, resultOpera } = this.state;
    const { verificationId } = this.props;
    let _resultList = resultList ? resultList : {};
    let _expandedKeys = this.getDefaultExpandedKeys();
    const _Interfaces = Interfaces[verificationId] ? Interfaces[verificationId] : [];
    let pcbs = _Interfaces.map(item => item.pcb);
    if (this.selectAllCancelAble) {
      this.selectAllCancelAble.cancel();
    }
    for (let _interface of _Interfaces) {
      const pcb = _interface.pcb;
      const fileIndex = files.findIndex(file => file.pcb === pcb);
      if (fileIndex < 0) {
        continue;
      }
      const findFile = files[fileIndex];
      if (!findFile.ports || !findFile.ports.length) {
        continue;
      }

      const portList = findFile.ports;
      const fileId = files[fileIndex].id;
      if (!_resultList[pcb]) {
        _resultList[pcb] = {};
      }
      if (!_resultList[pcb].Default) {
        let _default = [];
        for (let i = 0; i < portList.length; i++) {
          const port = portList[i];
          const rowName = `Port ${port.index} (${port.name})`;
          _default[i] = { rowName: rowName, id: `${rowName}::${fileId}`, children: [] };
          _default[i].children = portList.map(_port => {
            return {
              id: `${fileId}::${port.index - 1}::${_port.index - 1}`,
              name: `S(${port.index}, ${_port.index}) ${port.index !== _port.index ? _port.name : ''}`,
              color: this.getColorByIndex(fileId, port.index - 1, _port.index - 1),
              parentKey: `${rowName}::${fileId}`
            }
          })
        }
        _resultList[pcb].Default = { list: _default, show: _default[0] ? [_default[0].rowName] : [] };
      }
      _resultList[pcb].Default.list && _resultList[pcb].Default.list[0] && _expandedKeys.push(_resultList[pcb].Default.list[0].id);
    }
    const { portSelect = {} } = resultOpera;
    this.setState({
      resultList: _resultList,
      portSelect,
      expandedKeys: _expandedKeys,
    }, () => {
      if (Object.keys(portSelect).length) {
        this.showSavedCurves()
      } else {
        let _portSelect = {}, newPorts = [];
        pcbs.forEach(pcb => {
          /*  const _findFile = files.find(item => item.pcb === pcb); */
          const currentList = _resultList[pcb];
          if (currentList && currentList.Default && currentList.Default.list && currentList.Default.list.length > 0 && currentList.Default.list[0].children[0]) {
            const defaultList = currentList.Default.list[0];
            const defaultValues = [defaultList.children[0].id];
            const defaultKey = defaultList.rowName;
            _portSelect[defaultKey] = [...(_portSelect[defaultKey] || []), ...defaultValues];
            newPorts.push(...defaultValues);
          }
        })
        this.setState({
          portSelect: _portSelect
        }, () => {
          this.updateSelectedCurves(newPorts, null)
        })
      }
    })
  }

  findResultList = () => {
    const { files, Interfaces, resultList, resultOpera } = this.state;
    const { verificationId } = this.props;
    let _resultList = resultList ? resultList : {};
    let _expandedKeys = this.getDefaultExpandedKeys();;
    const displayMode = this.childComp.getDisplayMode();
    const _Interfaces = Interfaces[verificationId] ? Interfaces[verificationId] : [];
    let edit = false;
    if (this.selectAllCancelAble) {
      this.selectAllCancelAble.cancel();
    }
    for (let _interface of _Interfaces) {
      const pcb = _interface.pcb;
      const fileIndex = files.findIndex(file => file.pcb === pcb);
      if (fileIndex < 0) {
        continue;
      }
      const findFile = files[fileIndex];
      if (!findFile.ports || !findFile.ports.length) {
        continue;
      }
      const content = _interface.content ? _interface.content : {};
      const { signals, components, virtualComps } = content;
      if (!_resultList[pcb]) {
        _resultList[pcb] = {};
      }
      if (!_resultList[pcb].IL || _resultList[pcb].RL) {
        edit = true;
        const portList = findFile.ports;
        const { IL, RL, FEXT, NEXT } = getResultList({
          Signals: signals,
          Components: components,
          VirtualComps: virtualComps,
          portList,
          getColorByIndex: this.getColorByIndex,
          infoList: ["IL", "RL", "FEXT", "NEXT"],
          fileId: findFile.id
        });
        _resultList[pcb].IL = { list: IL, show: IL.map(item => item.rowName) };
        _resultList[pcb].RL = { list: RL, show: RL.map(item => item.rowName) };
        // If there is no FEXT or EXTX, do not expand the tree
        const FEXTShow = FEXT.filter(item => item.children && item.children.length) || []
        const EXTXShow = NEXT.filter(item => item.children && item.children.length) || []
        _resultList[pcb].FEXT = { list: FEXT, show: FEXTShow.map(item => item.rowName) };
        _resultList[pcb].NEXT = { list: NEXT, show: EXTXShow.map(item => item.rowName) };
        if (_resultList[pcb][displayMode]) {
          _expandedKeys.push(..._resultList[pcb][displayMode].list.map(it => it.id));
        }
      }
    }

    if (edit) {
      const { portSelect = {} } = resultOpera;
      this.setState({
        resultList: _resultList,
        portSelect,
        expandedKeys: _expandedKeys
      }, () => {
        if (Object.keys(portSelect).length) {
          this.showSavedCurves()
        }
      });
    }
  }

  _rowNameClick = (displayMode, value, pcb) => {
    let _resultList = { ...this.state.resultList };
    if (_resultList[pcb] && _resultList[pcb][displayMode]) {
      let _show = [..._resultList[pcb][displayMode].show];
      if (_show.includes(value)) {
        _show = _show.filter(item => item !== value);
      } else {
        _show.push(value);
      }
      _resultList[pcb][displayMode].show = _show;
      this.setState({
        resultList: _resultList
      });
    }
  };

  showSavedCurves = () => {
    const { portSelect, resultList } = this.state;
    const displayMode = this.childComp.getDisplayMode();
    const showCurvesIds = [];
    const pcbs = Object.keys(resultList);
    const rowNames = Object.keys(portSelect);
    const _resultList = { ...resultList };
    for (let pcb of pcbs) {
      const results = resultList[pcb];
      const result = results[displayMode];
      const filterRowNames = result.list.filter(item => rowNames.includes(item.rowName)).map(item => item.rowName);
      _resultList[pcb][displayMode].show = filterRowNames;
      filterRowNames.forEach(name => showCurvesIds.push(...(portSelect[name] || [])))
    }
    this.setState({
      resultList: _resultList
    }, () => {
      this.showDataCurves(showCurvesIds)
    })
  }

  showDataCurves = (idList) => {
    const { files } = this.state;
    if (!this.plot2d) {
      return;
    }
    const setting = this.childComp.getSetting();
    const curves = idList.map(d => {
      const [fileId, row, col] = strDelimited(d, "::");
      let parameter = Parameters.getParameter(fileId);
      if (!parameter) {
        return null;
      }
      const curveType = parameter.type; // simulation || target
      let fileIndex = files.findIndex(item => item.id === fileId);
      if (!files[fileIndex].ports || !parameter.ports) {
        return null;
      };
      return { parameter, fileIndex, row, col, curveType }
    });
    const _showCurves = sparameterShowCurves({
      parameters: Parameters,
      curves,
      param: setting.parameter,
      value: setting.value,
      sweep: false,
      files
    });
    this.selectAllCancelAble = makeCancelable(_showCurves)
    this.selectAllCancelAble.promise.then(resCurves => {
      if (resCurves) {
        this.plot2d.updateCurves(resCurves, true);
        resCurves.forEach(cur => {
          const _fileIndex = files.findIndex(item => item.id === cur.id);
          const color = files[_fileIndex].matrix[cur.row][cur.col].color;
          this.plot2d.resetColor({ id: cur.id, row: cur.row, col: cur.col, color: color });
        })
        this.plot2d.resetPlot();
        const axis = this.childComp.getAxis();
        const setting = this.childComp.getSetting();
        if (Parameters.getSize() > 0) {
          Parameters.changeAxis('x', { param: setting.parameter, value: setting.value, scale: axis.xScale });
          Parameters.changeAxis('y', { param: setting.parameter, value: setting.value, scale: axis.yScale });
        }
      };
    })
  }

  _changeSelectAll = (e, group, fileId) => {
    const check = e.target.checked;
    let { portSelect } = this.state;
    const prevSelect = portSelect[group.rowName] || [];
    let prevOtherPcbSelect = [];
    portSelect[group.rowName] && portSelect[group.rowName].forEach(item => {
      const [id] = strDelimited(item, "::");
      if (id !== fileId) {
        prevOtherPcbSelect.push(item);
      }
    })
    if (this.selectAllCancelAble) {
      this.selectAllCancelAble.cancel();
    }
    if (check) {
      portSelect[group.rowName] = [...prevOtherPcbSelect, ...group.children.map(d => d.id)];
    } else {
      portSelect[group.rowName] = [...prevOtherPcbSelect];
    };
    this.setState({
      portSelect: portSelect
    }, () => {
      this.setResultOpera({ portSelect })
    });
    if (check) {
      const allSelect = group.children.map(d => d.id);
      const newChecks = allSelect.filter(a => !prevSelect.includes(a));
      this.showDataCurves(newChecks)
    } else {
      const removedSelect = prevSelect.filter(item => !prevOtherPcbSelect.includes(item));
      const removeCurves = removedSelect.map(uncheck => {
        const [id, row, col] = strDelimited(uncheck, "::");
        return { id, row, col };
      })
      Parameters.removeCurves(removeCurves);
    };
  }

  setChannelState = (value, key) => {
    this.setState({
      [key]: value
    }, () => {
      if (key === 'portSelect') {
        this.setResultOpera({ portSelect: value })
      }
    })
  }

  updateExpandKeys = (keys) => {
    this.setState({
      expandedKeys: keys
    })
  }

  updateEndToEndExpandedKeys = (keys) => {
    this.setState({
      expandedEndToEndKeys: keys
    })
  }

  render() {
    const { files, portSelect, resultList, hasVcPCBs, hideIL, endToEndList, resultOpera, expandedKeys, expandedEndToEndKeys, endToEndCurveMouseObj, endToEndTree } = this.state;
    return <Sparameter
      onRef={(ref) => { this.childComp = ref }}
      files={files}
      portSelect={portSelect}
      resultList={resultList}
      endToEndList={endToEndList}
      endToEndTree={endToEndTree}
      plot2d={this.plot2d}
      hasVcPCBs={hasVcPCBs}
      hideIL={hideIL}
      resultOpera={resultOpera}
      setChannelState={this.setChannelState}
      defaultResultList={this.defaultResultList}
      findResultList={this.findResultList}
      settingChangeCB={this.settingChangeCB}
      expandedKeys={expandedKeys}
      updateExpandKeys={this.updateExpandKeys}
      expandedEndToEndKeys={expandedEndToEndKeys}
      endToEndCurveMouseObj={endToEndCurveMouseObj}
      updateEndToEndExpandedKeys={this.updateEndToEndExpandedKeys}
      {...this.resultListAction}
    />
  }

  fileNameClick = (id) => {
    const { files } = this.state;
    let index = files.findIndex(item => item.id === id);
    const parameter = files[index];
    if (parameter.ports && parameter.matrix) {
      this.setState((prevState) => {
        prevState.files[index].show = !prevState.files[index].show;
        return {
          files: prevState.files
        }
      });
      return;
    }
    this.getNpiFile(parameter, index);
  }

  getNpiFile = (parameter, index) => {
    const { verificationId } = this.props;
    return new Promise((resolve, reject) => {
      parameter.getNpiFile(index, verificationId).then(res => {
        this.setState((prevState) => {
          prevState.files[index] = { ...prevState.files[index], ...res, show: !prevState.files[index].show };
          return {
            files: prevState.files
          }
        }, () => {
          resolve(this.state.files);
        })
      })
    })
  }

  changePort = (values, key) => {
    let { portSelect } = this.state;

    if (!key || !Array.isArray(values)) {
      return;
    }

    if (!portSelect[key]) {
      portSelect[key] = [];
    }
    let prev = [...portSelect[key]];


    const newChecks = values.filter(p => !prev.includes(p));
    const unChecks = prev.filter(p => !values.includes(p));
    portSelect[key] = values;

    this.setState({
      portSelect: portSelect
    }, () => {
      this.setResultOpera({ portSelect })
    });

    this.updateSelectedCurves(newChecks, unChecks);
  }

  updateSelectedCurves = (newChecks, unChecks) => {
    if (unChecks) {
      const removeCurves = unChecks.map(uncheck => {
        const [id, row, col] = strDelimited(uncheck, "::");
        return { id, row, col };
      })
      Parameters.removeCurves(removeCurves);
    };

    if (newChecks) {
      this.showDataCurves(newChecks)
    }
  }

  changeEndToEndPorts = (values, key) => {
    let { portSelect } = this.state;

    if (!key || !Array.isArray(values)) {
      return;
    }

    if (!portSelect[key]) {
      portSelect[key] = [];
    }
    let prev = [...portSelect[key]];

    const newPorts = values.filter(p => !prev.includes(p));
    const deletePorts = prev.filter(p => !values.includes(p));
    portSelect[key] = values;
    this.setState({
      portSelect
    }, () => {
      this.setResultOpera({ portSelect })
    });
    if (deletePorts && deletePorts.length) {
      const removeCurves = deletePorts.map(uncheck => {
        const [id, row, col] = strDelimited(uncheck, "::");
        return { id, row, col };
      })
      Parameters.removeCurves(removeCurves);
    };

    if (newPorts && newPorts.length) {
      this.showEndToEndCurves(newPorts)
    }
  }

  showSavedEndToEndCurves = () => {
    const { portSelect } = this.state;
    const endToEndKeys = Object.keys(portSelect).filter(item => item.includes(`end-to-end@`));
    if (endToEndKeys.length) {
      const ids = endToEndKeys.reduce((prev, current) => ([...prev, ...portSelect[current]]), []);
      this.showEndToEndCurves(ids)
    }
  }

  showEndToEndCurves = (newPorts) => {
    let { endToEndList, files } = this.state;
    const setting = this.childComp.getSetting();
    const displayMode = this.childComp.getDisplayMode();
    const curves = newPorts.map(d => {
      let [id, row, col] = strDelimited(d, "::");
      let parameter = Parameters.getParameter(id);
      if (!parameter) {
        return null;
      }
      const [curveType, pcb1, pcb2, /* signal */] = strDelimited(id, "@");
      const index = endToEndList.findIndex(item => item.rowName === `${pcb1}@${pcb2}`);
      const signalIndex = index > -1 ? endToEndList[index].signals.findIndex(item => item.id === id) : -1;
      if (!parameter.ports || index < 0 || signalIndex < 0) {
        return null;
      };
      const curr = endToEndList[index].signals[signalIndex] || {};
      const mode = (curr[displayMode] || []).find(item => item.row === Number(row) && item.col === Number(col));
      if (!mode) {
        return null;
      }
      return { parameter, id, row, col, curveType, folderName: mode.folderName }
    });
    const _showCurves = sparameterShowCurves({
      parameters: Parameters,
      curves,
      param: setting.parameter,
      value: setting.value,
      sweep: false,
      files
    });
    this.selectAllCancelAble = makeCancelable(_showCurves)
    this.selectAllCancelAble.promise.then(resCurves => {
      if (resCurves) {
        this.plot2d.updateCurves(resCurves, true);
        resCurves.forEach(cur => {
          const _fileIndex = files.findIndex(item => item.id === cur.id);
          const color = files[_fileIndex].matrix[cur.row][cur.col].color;
          this.plot2d.resetColor({ id: cur.id, row: cur.row, col: cur.col, color: color });
        })
        this.plot2d.resetPlot();
        const axis = this.childComp.getAxis();
        const setting = this.childComp.getSetting();
        if (Parameters.getSize() > 0) {
          Parameters.changeAxis('x', { param: setting.parameter, value: setting.value, scale: axis.xScale });
          Parameters.changeAxis('y', { param: setting.parameter, value: setting.value, scale: axis.yScale });
        }
      };
    })
    /*   this.setState({
        endToEndList
      }) */
  }

  showCurve = (newCheck) => {
    const { files } = this.state;
    const setting = this.childComp.getSetting();
    let [id, row, col] = strDelimited(newCheck, "::");
    let parameter = Parameters.getParameter(id);
    if (!parameter) {
      return;
    }
    const curveType = parameter.type; // simulation || target
    let fileIndex = files.findIndex(item => item.id === id);
    if (!files[fileIndex].ports || !files[fileIndex].ports.length || !parameter.ports || !parameter.ports.length) {
      return;
    }
    Parameters.showCurve({ parameter, fileIndex, row, col, param: setting.parameter, value: setting.value, curveType }).then(curves => {
      if (curves) {
        files[fileIndex].matrix[row][col][curves.type] = curves.y;
        curves.visible = true;
        this.plot2d.updateCurves(curves, true);
        this.plot2d.resetPlot();
        if (!files[fileIndex].matrix || !files[fileIndex].matrix.length) {
          return;
        }
        const color = files[fileIndex].matrix[row][col].color;
        this.plot2d.resetColor({ id, row, col, color: color });
        const axis = this.childComp.getAxis();
        const setting = this.childComp.getSetting();
        Parameters.changeAxis('x', { param: setting.parameter, value: setting.value, scale: axis.xScale });
        Parameters.changeAxis('y', { param: setting.parameter, value: setting.value, scale: axis.yScale });
      }
    });
  }

  colorChange = (e, key) => {
    const [id, row, col] = strDelimited(key, "::");
    const value = e.toHexString()
    const { files, resultList } = this.state;
    const displayMode = this.childComp.getDisplayMode();
    let fileIndex = files.findIndex(item => item.id === id);
    const pcb = files[fileIndex].pcb;
    let _resultList = resultList[pcb];
    if (value) {
      files[fileIndex].matrix[row][col].color = value;
      if (_resultList && _resultList[displayMode] && _resultList[displayMode].list) {
        for (let group of _resultList[displayMode].list) {
          let _find = false;
          for (let child of group.children) {
            if (child.id === key) {
              child.color = value;
              _find = true;
              break;
            }
          }
          if (_find) {
            break;
          }
        }
      }

      this.setState({
        files,
        resultList: pcb && _resultList ? { ...resultList, pcb: _resultList } : { ...resultList }
      }, () => {
        this.plot2d.resetColor({ id, row: row, col: col, color: value })
        this.plot2d.redrawCurves();
      })
    }
  }

  settingChangeCB = () => {
    const { files } = this.state;
    const axis = this.childComp.getAxis();
    const setting = this.childComp.getSetting();
    Parameters.changeParameter({ parameters: files, setting, yScale: axis.yScale, xScale: axis.xScale });
    this.setResultOpera({ setting, axis })
  }

  setResultOpera = (newSetting) => {
    const { verificationId } = this.props;
    const { resultOpera } = this.state;
    this.setState({
      resultOpera: { ...resultOpera, ...newSetting }
    }, () => {
      resultOperation.setOperationByKey(verificationId, CHANNEL, { ...resultOpera, ...newSetting })
    })
  }

  resultListAction = {
    changePort: this.changePort,
    colorChange: this.colorChange,
    _rowNameClick: this._rowNameClick,
    _changeSelectAll: this._changeSelectAll,
    // fileDownload: this.fileDownload,
    fileNameClick: this.fileNameClick,
    changeEndToEndPorts: this.changeEndToEndPorts,
    setResultOpera: this.setResultOpera
  }
}

const mapState = (state) => {
  const { resultReducer: { channelList, resultInfo }, project } = state.SierraReducer;
  const { currentProjectId, verificationName } = project;
  const { verificationId, verificationSubId } = resultInfo;
  return {
    interfaceName: verificationName,
    channelList,
    verificationId,
    projectId: currentProjectId,
    verificationSubId
  }
}

export default connect(mapState, null)(Channel);